import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Formsy from 'formsy-react';
import { autobind } from 'core-decorators';

import { submitContactForm } from 'services/api';

import Alert from 'AppComponents/Alert';
import { Input, TextArea } from 'AppComponents/Forms/Formsy';
import SubmitButton from 'AppComponents/SubmitButton';
import { byIdShape } from 'utils/propTypes';

import Page from '../index';

import './styles.scss';


class Contact extends Component {

  static propTypes = {
    currentUser: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    usersById: byIdShape.isRequired,
  };

  static defaultProps = {
    currentUser: null,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      enableSubmit: false,
      isSubmitting: false,
      serverError: null,
      successMsg: null,
    };
  }

  @autobind
  handleSubmit(data, resetForm, invalidateForm) {
    this.setState({ isSubmitting: true }, () => {
      submitContactForm(data).then(({ error }) => {
        this.setState({ isSubmitting: false });
        if (error) {
          if (typeof error === 'object') {
            this.setState({ serverError: error.detail });
            delete error.detail;
            const errors = {};
            Object.keys(error).forEach((field) => {
              errors[field] = error[field][0];
            });
            invalidateForm(errors);
          } else {
            this.setState({ serverError: 'An unknown error occurred. Please try again.' });
          }
        } else {
          this.setState({
            successMsg: 'Thanks! We\'ve received your message and will respond soon.',
            serverError: null,
          });
          resetForm();
        }
      });
    });
  }

  render() {
    let user;
    let name;
    if (this.props.currentUser) {
      user = this.props.usersById[this.props.currentUser];
      name = [];
      if (user.first_name) name.push(user.first_name);
      if (user.last_name) name.push(user.last_name);
      if (name.length > 0) name = name.join(' ');
    } else {
      user = null;
      name = '';
    }

    return (
      <Page slug='contact' styleName='contact'>

        <Alert type='danger' display={this.state.serverError && true}>
          <strong>Error: </strong>{ this.state.serverError }
        </Alert>

        <Alert type='success' display={this.state.successMsg && true}>
          { this.state.successMsg }
        </Alert>

        <Formsy.Form
          className='form'
          onValid={() => this.setState({ enableSubmit: true })}
          onInvalid={() => this.setState({ enableSubmit: false })}
          onValidSubmit={this.handleSubmit}
          noValidate
        >

          <Input
            name='name'
            label='Your Name'
            value={name}
          />

          <Input
            name='email'
            label='Contact Email'
            validations='isEmail'
            validationError='Must be a valid email'
            value={user && user.email ? user.email : ''}
            required
          />

          <Input
            name='subject'
            label='Subject'
            required
          />

          <TextArea
            name='body'
            label='Message'
            rows={4}
            required
          />

          <div className='form-footer'>
            <div className='aligned-with-input'>
              <SubmitButton
                label='Send'
                enabled={this.state.enableSubmit}
                isSubmitting={this.state.isSubmitting}
              />
            </div>
          </div>

        </Formsy.Form>
      </Page>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.auth.currentUser,
  isLoggedIn: state.auth.isLoggedIn,
  usersById: state.users.byId,
});

export default connect(
  mapStateToProps, {
  },
)(Contact);



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Page/Contact/index.jsx